import React, { useMemo } from 'react'
import { Text, Stack, Skeleton, Box, Flex, Tooltip  } from '@chakra-ui/react'
import { IDashboardPlan } from 'services/IApi'
import { InfoOutlineIcon } from '@chakra-ui/icons'
import currencySymbol from 'utils/functions/currencySymbolMap/currencySymbol'
import { useMediaQuery } from 'react-responsive'

interface ICompanySubscriptionResumeProps {
  isLoadingScreen: boolean
  plan: IDashboardPlan  
}

// Precios Subscription Resume
const Price = ({ isLoadingScreen, plan }: ICompanySubscriptionResumeProps) => {
  const isMobile = useMediaQuery({ query: '(max-width: 480px)' })
  const additionalServicesQuantity: string = useMemo(() => plan?.additionalServices?.charAt(0), [plan])
  const price = plan?.price === '0' ? 'Sin costo' : `${currencySymbol('$')}${Number(plan?.price).toLocaleString('es-AR')}`
  const priceIva = plan?.price === '0' ? '' : `+IVA por mes`

  return (
  <Stack data-testid='prices' flexDir='column' pb='12px' gap='12px' borderBottomWidth='1px' borderBottomStyle='solid' borderBottomColor='secondary.100' borderColor='#B2B7C4'>
    <Skeleton isLoaded={!isLoadingScreen}>              
      <Box flex={1} >
        <Text data-testid='prices-title' textStyle='overlineLg' size='4xs' line-height='xs' letterSpacing='1.2px' mt='12px' color='secondary.500'>Plan solicitado</Text>
      </Box>
      <Flex flex={1} flexDir='row' justifyContent='space-between' m='0 !important' gap='24px'>
        <Flex flexDir='row' alignItems='center' gap='4px'>
          <Text data-testid='prices-plan-name' textStyle='h5Bold' size='md' line-height='lg' color='tertiary.500' height='28px'>{plan?.name}</Text>
          {+additionalServicesQuantity !== 0 && !isMobile &&
            <Text data-testid='prices-additionalServices' textStyle='labelSm' color='grey.120'>&nbsp;&nbsp;+{plan?.additionalServices}</Text>
          }
        </Flex>
        <Text data-testid='prices-detail' gap='4px' >
          {plan?.type === 'variable' &&
            <>
              <Tooltip
                data-testid='prices-detail-tooltip'
                label='Precio variable sujeto a condiciones de los servicios adicionales'
                aria-label='A tooltip'
                placement='top'
              >
                <InfoOutlineIcon color='neutral.20' mx={2} boxSize={'14.67px'} />
              </Tooltip>
              <Text textStyle='labelMd' mr='4px' as='span'>Desde</Text>
            </>
          }
          <Text data-testid='prices-price' textStyle='h6' fontWeight='700' size='sm' line-height='2xm' color='secondary.500' as='span'>{price}</Text>
          <Text data-testid='prices-priceIva' textStyle='labelMd' fontWeight='400' size='3sm' line-height='xs' textAlign='center' color='secondary.500' as='span'>{priceIva}</Text>
        </Text>
      </Flex>
      {+additionalServicesQuantity !== 0 && isMobile &&
        <Box flex={1} >
          <Text data-testid='prices-additionalServices-mobile' textStyle='labelSm' color='grey.120'>+{plan?.additionalServices}</Text>
        </Box>
      }
    </Skeleton>
  </Stack>)  
}

export default Price